import { Injectable } from '@angular/core';
import { Pago } from 'src/app/pago/models/Pago.model';
import { ConfiguracionDePago } from 'src/app/pago/models/ConfiguracionDePago.model';
import { DatalayerEvent } from 'src/app/pago/models/DatalayerEvent.model';
import { IdProducto } from 'src/app/pago/enums/IdProducto.enum';
import { CategoriaGtm } from 'src/app/pago/enums/CategoriaGtm.enum';
import { Metadata } from 'src/app/pago/models/Metadata.model';

@Injectable({
  providedIn: 'root',
})
export class DatalayerRegisterPagoService {
  static readonly INICIO_PAGO = 'inicio-pago';
  static readonly PREPOLIZA = 'Prepoliza';
  static readonly PLAN = 'Plan';
  static readonly WITH_RENOVACION = 'Si';
  static readonly WITH_OUT_RENOVACION = 'No';

  build(
    pago: Pago,
    configuracionDePago: ConfiguracionDePago,
    metodoPago: string
  ): DatalayerEvent {
    return {
      event: DatalayerRegisterPagoService.INICIO_PAGO,
      ecommerce: {
        checkout: {
          actionField: { step: 1, option: metodoPago },
          products: {
            category: this.getCategoryGtm(pago.idProducto),
            subtotal: pago.subTotal,
            value: pago.total,
            name: pago.idProducto,
            quantity: 1,
            prepoliza: this.getMetadata(
              configuracionDePago,
              DatalayerRegisterPagoService.PREPOLIZA
            ),
            periodicidad: this.getMetadata(
              configuracionDePago,
              DatalayerRegisterPagoService.PLAN
            ),
            renovacion: pago.renovacionAutomatica
              ? DatalayerRegisterPagoService.WITH_RENOVACION
              : DatalayerRegisterPagoService.WITH_OUT_RENOVACION,
          },
        },
      },
    };
  }

  getCategoryGtm(idProducto: string): string {
    switch (idProducto) {
      case IdProducto.PRODUCTO_PROTECCION_DIGITAL_PERSONAS:
        return CategoriaGtm.ESTILO_DE_VIDA;
      case IdProducto.PRODUCTO_VIDA:
        return CategoriaGtm.VIDA;
      case IdProducto.PRODUCTO_SALUD_DIGITAL:
        return CategoriaGtm.SALUD;
      case IdProducto.PRODUCTO_PAC:
        return CategoriaGtm.SALUD;
      case IdProducto.PRODUCTO_ARRENDAMIENTO:
      case IdProducto.PRODUCTO_ARRENDAMIENTO_RENOVACION:
        return CategoriaGtm.ARRENDAMIENTO;
      default:
        return CategoriaGtm.MOVILIDAD;
    }
  }

  getMetadata(configuracionDePago: ConfiguracionDePago, key: string): string {
    const buscarDato: Metadata = configuracionDePago.metadata.find(
      metadata => metadata.dato === key
    );
    return buscarDato ? buscarDato.valor : null;
  }
}
